import React, { Component, Fragment } from 'react';
import ProfileContainer from './containers/profileContainer';
import DropdownNavigation from '../../components/DropdownNavigation';
import { Breadcrumb } from 'react-bootstrap';
import { Col, Row } from 'antd';
import defaultImageUrl from '../../img/user.png';
import ProfileImage from '../patients/Modals/ProfileImage';
import { connect } from 'react-redux';
import { uploadImageDirect } from '../../components/file-uploader/actions';
import { ImageSelector } from '../../components/file-uploader';
import _, { orderBy } from 'lodash';
import { imageValidator } from '../groups/validators/groupExercises';
import { updateUserProfile, updateCornerPhoto } from '../users/actions/users';
import { Link } from 'react-router-dom';
import { CloseOutlined, EditFilled } from '@ant-design/icons';
import {
  Form,
  Select,
  Tooltip,
  Typography,
  Button,
  notification,
  Switch,
} from 'antd';
import setNotification from '../../utils/setNotification.utils';

import { getRecoil, setRecoil } from 'recoil-nexus';
import states from '../../states';

class profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      img: null,
      cropping: false,
      validImg: false,
      closed: false,
      loading: false,
      uploadLoading: false,
      editDefaultLocation: false,
      preferences: {
        messaging: 'enabled',
        location: null,
        rtmStatus: 'disabled',
        notifyBillableCodes: 'enabled',
        promptLocationPopup: 'disabled',
      },
    };
  }

  componentDidMount() {
    const {
      props: {
        visibleProfile: { Preferences },
      },
      state: { preferences },
    } = this;

    const userState = getRecoil(states.user);
    if (userState.details && userState.details.preferences) {
      const messaging =
        userState.details.preferences.messaging || preferences.messaging;
      const location =
        userState.details.preferences.location || preferences.location;
      const rtmStatus =
        userState.details.preferences.rTMStatus || preferences.rtmStatus;
      const notifyBillableCodes =
        userState.details.preferences.notifyBillableCodes ||
        preferences.notifyBillableCodes;
      const promptLocationPopup =
        userState.details.preferences.promptLocationPopup ||
        preferences.promptLocationPopup;

      this.setState({
        preferences: {
          messaging,
          location,
          rtmStatus,
          notifyBillableCodes,
          promptLocationPopup,
        },
      });
    }

    this.setState({ img: this.createBaseImageUrl() });
  }

  createBaseImageUrl = () => {
    const { GroupId, Sub } = this.props.visibleProfile;
    const url = encodeURI(
      `https://ptwired-exercise-images-prod.s3.amazonaws.com/${GroupId}/${Sub}.jpg`
    );

    return url.replace('@', '%40');
  };

  handleFiles = files => {
    const {
      visibleProfile: { EmailAddress, GroupId },
    } = this.props;
    const { base64 } = files;
    this.setState({ img: base64 });
    console.log(GroupId, EmailAddress);
    this.uploadImage(GroupId, EmailAddress, base64);
  };

  startCropping = () => {
    const { img } = this.state;

    img && this.setState({ cropping: true });
  };

  stopCropping = () => {
    this.setState({ cropping: false });
  };

  uploadImage = (groupId, emailAddress, file) => {
    const { dispatch } = this.props;
    dispatch(uploadImageDirect(`${groupId}/${emailAddress}.jpg`, file));
  };

  toggleMessaging = async value => {
    const messagingBool = value ? 'enabled' : 'disabled';

    try {
      const {
        props: {
          visibleProfile: { Sub, Preferences },
          dispatch,
        },
        state: { preferences },
      } = this;

      const preferencesObj = {
        ...Preferences,
        Messaging: messagingBool,
      };

      this.setState({ loading: true });

      await dispatch(updateUserProfile(Sub, preferencesObj)).then(() => {
        this.setState({
          preferences: {
            ...preferences,
            messaging: messagingBool,
          },
        });

        if (!value) {
          setRecoil(states.messages, {
            list: [],
          });
        }

        notification.success({
          message: 'Success!',
          description: 'You have set your messaging status.',
        });
      });
    } catch (error) {
      notification.error({
        message: 'Error!',
        description: 'An error occurred while saving, please try again.',
      });
    } finally {
      this.setState({ loading: false });

      const userState = getRecoil(states.user);
      setRecoil(states.user, {
        ...userState,
        details: {
          ...userState.details,
          preferences: {
            ...userState.details.preferences,
            messaging: messagingBool,
          },
        },
      });
    }
  };

  toggleRTMStatus = async value => {
    const rtmStatusBool = value ? 'enabled' : 'disabled';

    try {
      const {
        props: {
          visibleProfile: { Sub, Preferences },
          dispatch,
        },
        state: { preferences },
      } = this;

      const preferencesObj = {
        ...Preferences,
        RTMStatus: rtmStatusBool,
      };

      this.setState({ loading: true });

      await dispatch(updateUserProfile(Sub, preferencesObj)).then(() => {
        this.setState({
          preferences: {
            ...preferences,
            rtmStatus: rtmStatusBool,
          },
        });

        notification.success({
          message: 'Success!',
          description: 'You have set your default RTM status.',
        });
      });
    } catch (error) {
      notification.error({
        message: 'Error!',
        description: 'An error occurred while saving, please try again.',
      });
    } finally {
      this.setState({ loading: false });

      const userState = getRecoil(states.user);
      setRecoil(states.user, {
        ...userState,
        details: {
          ...userState.details,
          preferences: {
            ...userState.details.preferences,
            rTMStatus: rtmStatusBool,
          },
        },
      });
    }
  };

  toggleNotification = async value => {
    const notifyBillableCodesBool = value ? 'enabled' : 'disabled';

    try {
      const {
        props: {
          visibleProfile: { Sub, Preferences },
          dispatch,
        },
        state: { preferences },
      } = this;

      const preferencesObj = {
        ...Preferences,
        NotifyBillableCodes: notifyBillableCodesBool,
      };

      this.setState({ loading: true });

      await dispatch(updateUserProfile(Sub, preferencesObj)).then(() => {
        this.setState({
          preferences: {
            ...preferences,
            notifyBillableCodes: notifyBillableCodesBool,
          },
        });

        notification.success({
          message: 'Success!',
          description: `You have ${notifyBillableCodesBool} your notification for RTM billable codes.`,
        });
      });
    } catch (error) {
      notification.error({
        message: 'Error!',
        description: 'An error occurred while saving, please try again.',
      });
    } finally {
      this.setState({ loading: false });

      const userState = getRecoil(states.user);
      setRecoil(states.user, {
        ...userState,
        details: {
          ...userState.details,
          preferences: {
            ...userState.details.preferences,
            notifyBillableCodes: notifyBillableCodesBool,
          },
        },
      });
    }
  };

  togglePromptLocationPopup = async value => {
    const promptLocationPopupBool = value ? 'enabled' : 'disabled';

    try {
      const {
        props: {
          visibleProfile: { Sub, Preferences },
          dispatch,
        },
        state: { preferences },
      } = this;

      const preferencesObj = {
        ...Preferences,
        PromptLocationPopup: promptLocationPopupBool,
      };

      await dispatch(updateUserProfile(Sub, preferencesObj)).then(() => {
        this.setState({
          preferences: {
            ...preferences,
            promptLocationPopup: promptLocationPopupBool,
          },
        });

        notification.success({
          message: 'Success!',
          description: `You have ${promptLocationPopupBool} the Prompt Location Pop-up display.`,
        });
      });

      this.setState({ loading: true });
    } catch (error) {
      notification.error({
        message: 'Error!',
        description: 'An error occurred while saving, please try again.',
      });
    } finally {
      this.setState({ loading: false });

      const userState = getRecoil(states.user);
      setRecoil(states.user, {
        ...userState,
        details: {
          ...userState.details,
          preferences: {
            ...userState.details.preferences,
            promptLocationPopup: promptLocationPopupBool,
          },
        },
      });
    }
  };

  setDefaultLocation = async location => {
    try {
      const {
        props: {
          visibleProfile: { Sub, Preferences },
          dispatch,
        },
        state: { preferences },
      } = this;

      const preferencesObj = { ...Preferences, ...location };

      this.setState({ loading: true });

      await dispatch(updateUserProfile(Sub, preferencesObj)).then(() => {
        this.setState({
          editDefaultLocation: false,
          preferences: {
            ...preferences,
            location: location.Location,
          },
        });

        notification.success({
          message: 'Success!',
          description: 'You have set your default location.',
        });
      });
    } catch (error) {
      notification.error({
        message: 'Error!',
        description: 'An error occurred while saving, please try again.',
      });
    } finally {
      this.setState({ loading: false });

      const userState = getRecoil(states.user);
      setRecoil(states.user, {
        ...userState,
        details: {
          ...userState.details,
          preferences: {
            ...userState.details.preferences,
            location: location.Location,
          },
        },
      });
    }
  };

  getSelectedClinicName = clinicId => {
    const {
      visibleProfile: { Clinics },
    } = this.props;

    let selectedClinicDetails =
      Clinics && Clinics.find(clinic => clinic.Id === clinicId);

    return selectedClinicDetails ? selectedClinicDetails.ClinicName : null;
  };

  handleFileSelected = (x, errors) => {
    const isValid = _.isEmpty(errors);

    if (isValid) {
      this.file = x;
      this.setState({ cropping: true });
    } else {
      console.log('errors', errors);
      setNotification(
        'error',
        'Upload Failed!',
        'Required upload image size is less than or equal to 1MB.'
      );
    }
  };

  handleImageCrop = async (file, base64) => {
    const {
      props: {
        dispatch,
        visibleProfile: { GroupId, Sub },
      },
    } = this;

    try {
      this.setState({ uploadLoading: true });

      await dispatch(
        uploadImageDirect(`${GroupId}/${Sub}.jpg`, file),
        await dispatch(updateCornerPhoto(base64))
      );

      this.setState({ img: base64, cropping: false });
      this.file = null;

      setNotification(
        'success',
        'Upload Successful',
        'You have updated your profile photo.'
      );
    } catch (error) {
      console.log('error', error);
      setNotification(
        'error',
        'Upload Failed!',
        'An error occurred while saving profile photo.'
      );
    } finally {
      this.setState({ uploadLoading: false });
    }
  };

  handleFileRemoved = x => {
    this.removeFile = x;
  };

  onSubmit = file => {
    console.log(file);
  };

  hideCrop = () => {
    this.setState({ cropping: false });
  };

  onExit = () => {
    this.setState({ img: null });
  };

  closeButton = () => {
    this.setState({ cropping: false });
  };

  orderClinics = clinics => {
    try {
      const sorted = orderBy(clinics, ['ClinicName'], ['asc']);
      return sorted;
    } catch (error) {
      return [];
    }
  };

  render() {
    const {
      toggleMessaging,
      setDefaultLocation,
      toggleRTMStatus,
      toggleNotification,
      togglePromptLocationPopup,
      handleFileSelected,
      handleFileRemoved,
      file,
      hideCrop,
      handleImageCrop,
      onExit,
      closeButton,
      state: {
        img,
        cropping,
        loading,
        editDefaultLocation,
        uploadLoading,
        preferences,
      },
      props: {
        visibleProfile: {
          Role,
          imgUrl,
          Clinics,
          GroupInfo: { EnableRTM },
        },
      },
    } = this;

    const clinicList = this.orderClinics(Clinics);

    return (
      <React.Fragment>
        {cropping && (
          <ProfileImage
            show={cropping}
            onHide={hideCrop}
            image={file}
            onSubmit={handleImageCrop}
            closeButton={closeButton}
            onExit={onExit}
            uploadLoading={uploadLoading}
          />
        )}

        <DropdownNavigation />
        <div className="ptw-main-body">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={Role === 'ga' ? '/administrator/' : '/patients'}>
                {Role === 'ga' ? 'Admin' : 'Patients'}
              </Link>
            </Breadcrumb.Item>
            <span> &raquo; </span>
            <Breadcrumb.Item active>My Profile</Breadcrumb.Item>
          </Breadcrumb>
          <Row gutter={[16, 16]}>
            <Col md={10} lg={10}>
              <ImageSelector
                ref={selector => {
                  this.selector = selector;
                }}
                isUser={true}
                selectorType={'PROFILE_PHOTO'}
                src={imgUrl ? imgUrl : img}
                defaultImageUrl={defaultImageUrl}
                imageValidator={imageValidator}
                onFileSelected={handleFileSelected}
                onFileRemoved={handleFileRemoved}
                height={125}
                width={125}
              >
                onExit={onExit}
              </ImageSelector>
            </Col>
            <Col md={14} lg={14}>
              <ProfileContainer />

              <Row gutter={[0, 16]} className="mt-4 mb-4">
                <Col lg={2} md={2}>
                  <Switch
                    style={{ marginTop: 14 }}
                    disabled={loading}
                    checked={preferences.messaging === 'enabled'}
                    onClick={toggleMessaging}
                  />
                </Col>

                <Col md={22} lg={22}>
                  <h4>Enable Messaging</h4>
                  <p>
                    Allow your patients to send you secure messages through the
                    patient application.
                  </p>
                </Col>

                {EnableRTM && typeof EnableRTM === 'boolean' && !!EnableRTM && (
                  <>
                    <Fragment>
                      <Col lg={2} md={2}>
                        <Switch
                          style={{ marginTop: 14 }}
                          disabled={loading}
                          checked={preferences.rtmStatus === 'enabled'}
                          onClick={toggleRTMStatus}
                        />
                      </Col>

                      <Col lg={22} md={22}>
                        <h4>Default RTM Status</h4>
                        <p>
                          RTM status is <strong>{preferences.rtmStatus}</strong>{' '}
                          by default.
                        </p>
                      </Col>
                    </Fragment>

                    <Fragment>
                      <Col lg={2} md={2}>
                        <Switch
                          style={{ marginTop: 14 }}
                          disabled={loading}
                          checked={
                            preferences.notifyBillableCodes === 'enabled'
                          }
                          onClick={toggleNotification}
                        />
                      </Col>

                      <Col lg={22} md={22}>
                        <h4>Enable Billable Codes Notification</h4>
                        <p>
                          Email notification for RTM billable codes is{' '}
                          <strong>{preferences.notifyBillableCodes}</strong>.
                        </p>
                      </Col>
                    </Fragment>
                  </>
                )}

                <Col md={2} lg={2}>
                  <Switch
                    style={{ marginTop: 14 }}
                    disabled={loading}
                    checked={preferences.promptLocationPopup === 'enabled'}
                    onClick={togglePromptLocationPopup}
                  />
                </Col>

                <Col md={22} lg={22}>
                  <h4>Display Prompt Location Pop-up</h4>
                  <p>
                    Prompt Location Pop-up display is currently{' '}
                    <strong>{preferences.promptLocationPopup}</strong>.
                  </p>
                </Col>

                {Array.isArray(Clinics) && Clinics.length > 0 && (
                  <Fragment>
                    <Col md={2} lg={2}>
                      <Tooltip title="Edit Default Location">
                        <Button
                          type="link"
                          disabled={loading}
                          onClick={() => {
                            this.setState({
                              editDefaultLocation: !editDefaultLocation,
                            });
                          }}
                          style={{
                            paddingLeft: 8,
                            color: loading ? '' : 'black',
                          }}
                        >
                          {editDefaultLocation ? (
                            <CloseOutlined style={{ fontSize: 28 }} />
                          ) : (
                            <EditFilled style={{ fontSize: 28 }} />
                          )}
                        </Button>
                      </Tooltip>
                    </Col>

                    <Col md={22} lg={22}>
                      <h4>Default Location</h4>

                      {editDefaultLocation ? (
                        <Form
                          initialValues={{ Location: preferences.location }}
                          layout="inline"
                          onFinish={val => setDefaultLocation(val)}
                        >
                          <Form.Item
                            style={{ width: '45%' }}
                            name="Location"
                            rules={[
                              {
                                required: true,
                                message: 'Default location is required.',
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              name="Location"
                              placeholder="Select default location"
                              size="large"
                            >
                              {clinicList.map((clinic, index) => {
                                const { Id, ClinicName } = clinic;

                                if (index === 0) {
                                  return (
                                    <Select.Option selected key={Id} value={Id}>
                                      {ClinicName}
                                    </Select.Option>
                                  );
                                } else {
                                  return (
                                    <Select.Option key={Id} value={Id}>
                                      {ClinicName}
                                    </Select.Option>
                                  );
                                }
                              })}
                            </Select>
                          </Form.Item>

                          <Form.Item>
                            <Button
                              className="ptw-btn btn-primary"
                              type="primary"
                              size="large"
                              htmlType="submit"
                              loading={loading}
                            >
                              Save Changes
                            </Button>
                          </Form.Item>
                        </Form>
                      ) : (
                        <Typography.Text>
                          {this.getSelectedClinicName(preferences.location)}{' '}
                          <Typography.Text type="secondary">
                            {preferences.location
                              ? `(${preferences.location})`
                              : 'Not selected a default location yet.'}
                          </Typography.Text>
                        </Typography.Text>
                      )}
                    </Col>
                  </Fragment>
                )}
              </Row>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  visibleProfile: state.visibleProfile,
});

export default connect(mapStateToProps)(profile);
